import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  LinearProgress,
  Chip,
  Alert,
} from "@mui/material";
import { get_admin_logs } from "../Api service/APIvariables";
import CustomPagination from "./CustomPagination";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchLogs = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");
      if (!user_id || !token) return;

      const formData = new FormData();
      formData.append("user_id", user_id);

      const res = await fetch(get_admin_logs, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (!data.error) {
        setLogs(data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const getLogTypeChip = (type) => {
    switch (type) {
      case "user_signup":
        return <Chip label="New User" color="info" size="small" />;
      case "payment":
        return <Chip label="Payment" color="success" size="small" />;
      case "card_scan":
        return <Chip label="Card Scan" color="warning" size="small" />;
      default:
        return <Chip label={type} size="small" />;
    }
  };

  return (
    <Box sx={{ padding: 4, width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
      <Typography variant="h4" fontWeight="bold" sx={{ mb: 1, color: "#453c72" }}>
        Activity Logs
      </Typography>
      <Typography variant="subtitle1" color="textSecondary" sx={{ mb: 3 }}>
        Audit trail of important user interactions, signups, and payments.
      </Typography>

      <Alert severity="warning" sx={{ mb: 4, borderRadius: 2 }}>
        System Logging module is currently disabled by environment variables (DISABLE_LOGGING_MODULE=true). Showing general transactional logs.
      </Alert>

      {isLoading ? (
        <LinearProgress color="secondary" sx={{ borderRadius: 2 }} />
      ) : (
        <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2, overflowX: "auto" }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
              <TableRow>
                <TableCell><strong>Timestamp</strong></TableCell>
                <TableCell><strong>Event Type</strong></TableCell>
                <TableCell><strong>Details</strong></TableCell>
                <TableCell><strong>User Context</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((log, index) => (
                <TableRow key={index} hover>
                  <TableCell sx={{ color: "text.secondary" }}>
                    {new Date(log.created_at).toLocaleString()}
                  </TableCell>
                  <TableCell>{getLogTypeChip(log.log_type)}</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>{log.details}</TableCell>
                  <TableCell>{log.email || "System/Cron"}</TableCell>
                </TableRow>
              ))}
              {logs.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 3, color: "text.secondary" }}>
                    No activities recorded.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: "16px",
            marginRight: "auto",
          }}
        >
          <CustomPagination
            count={logs.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              fontSize: "12px",
              width: "auto",
              justifyContent: "space-between",
              marginBottom: 2,
            }}
          />
        </div>
      )}
    </Box>
  );
}
